import http from '../jslibs/axios/http';

//标签管理 获取标签列表
export const getLabelList = () => (http.get('/v1/cms/Tag'))

//标签管理 新增标签
export const addLabel = data => (http.post('/v1/cms/Tag', data))

//标签管理 编辑标签
export const editLabel = data => (http.put(`/v1/cms/Tag/${data.id}`, data))

//标签管理 删除标签
export const deleteLabel = data => (http.delete(`/v1/cms/Tag/${data.id}`))